import * as React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import CustomCardWithBorder from "../CustomCardWithBorder";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import EditIcon from "@mui/icons-material/Edit";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import HearingIcon from "@mui/icons-material/Hearing";
import { Icon } from "@iconify/react";

export default function RoundedTabs({
  tabs = [],
  selected = 0,
  onChange = () => {},
  icons = [],
}) {
  console.log("tabs", tabs);

  // Dynamic icon mapping
  const getIcon = (name) => {
    switch (name.toLowerCase()) {
      case "reading":
        return <MenuBookIcon fontSize="small" />;
      case "writing":
        return <EditIcon fontSize="small" />;
      case "speaking":
        return <Icon icon="mingcute:mic-2-fill" style={{ fontSize: "20px" }} />;
      case "listening":
        return <HearingIcon fontSize="small" />;
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        width: `${tabs?.length * 140}px`, // 120px per tab, adjust as needed
        minWidth: "100px", // optional minimum width
      }}
    >
      <Tabs
        value={selected}
        onChange={onChange}
        TabIndicatorProps={{ style: { display: "none" } }}
        sx={{
          minHeight: 0,
          fontSize: "12px",
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 700,
            color: "#572575",
            padding: "4px 12px",
            minHeight: 0,
            borderRadius: 2,
            fontFamily: "Inter",
            display: "flex",
            alignItems: "center !important", // force align
            justifyContent: "center",
            minHeight: 32, // height of the tab
          },
          "& .MuiTab-root.Mui-selected": {
            minHeight: 32, // must match for selected state
          },

          "& .MuiTab-root.MuiTab-labelIcon": {
            flexDirection: "row !important", // icon + label inline
          },

          "& .MuiTab-root .MuiTab-iconWrapper": {
            marginRight: "6px !important", // gap between icon + text
            marginBottom: "0 !important", // remove default bottom spacing
          },
          "& .Mui-selected": {
            backgroundColor: "#572575",
            color: "#fff !important",
            minHeight: "32px",
          },
        }}
      >
        {tabs?.map((tab, index) => (
          <Tab
            key={index}
            label={tab.name} // <-- fixed here
            icon={getIcon(tab.name)}
            iconPosition={icons[index] ? "start" : undefined}
          />
        ))}
      </Tabs>
    </Box>
  );
}
